import React from 'react';

const Loading = () => {
  return (
    <div className='loader'>
      <h3>loading</h3>
    </div>
  );
};

export default Loading;
